const formatErrorForReport = (error) => {
    const message = String(error);
    const stack = error?.stack ? String(error.stack).trim() : '';

    if (!stack) return message;
    if (stack.startsWith(message)) return stack;

    return `${message}\n\nStack:\n${stack}`;
};

export default formatErrorForReport;
